import React from 'react'

function SvgEtablissement() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
<path d="M6.96436 17.4643H2.96435C1.85978 17.4643 0.964348 16.5689 0.964355 15.4643L0.964433 3.46434C0.96444 2.35978 1.85987 1.46436 2.96443 1.46436H11.9647C13.0692 1.46436 13.9647 2.35979 13.9647 3.46436V7.46435M4.46467 5.46435H10.4647M4.46467 8.46435H10.4647M4.46467 11.4644H7.46467M9.96452 14.7069L14.2072 10.4642L17.0356 13.2927L12.7929 17.5353H9.96452V14.7069Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default SvgEtablissement